"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function bcn(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M18.0441 12.7301C17.5716 12.2081 16.8921 11.8841 16.0041 11.7581V11.7394C16.7819 11.6134 17.3931 11.2946 17.8086 10.7846C18.2303 10.2788 18.4593 9.64011 18.4551 8.98162C18.4551 7.88587 18.1026 7.14112 17.3721 6.55537C16.6416 5.97037 15.5451 5.77762 14.0594 5.77762H8.44862V10.9999H5.22662V13.0001H14.0219C14.7141 13.0001 15.2339 13.0489 15.5774 13.3256C15.9209 13.6024 16.0964 13.9601 16.0964 14.4889C16.0964 15.0176 15.9231 15.4691 15.5774 15.7526C15.2324 16.0354 14.7119 16.2221 14.0219 16.2221H11.0039V14.6666H8.44862V18.2224H14.2439C15.7176 18.2224 16.8441 17.8376 17.6256 17.2399C18.4064 16.6421 18.7731 15.7594 18.7731 14.6756C18.7828 13.9586 18.5226 13.2642 18.0441 12.7301ZM13.6994 10.9946H11.0039V7.77262H13.6994C15.0854 7.77262 15.7769 8.31337 15.7769 9.38362C15.7769 10.4539 15.0854 10.9946 13.6994 10.9946Z", fill: color }));
}
exports["default"] = bcn;
//# sourceMappingURL=bcn.js.map